<template>
  <div class="animated fadeIn"> 
    <b-row>
      <b-col sm="12">
        <b-card>
          <div slot="header">
            <strong style="margin-left: 0.9rem;">Mark Delivery</strong>
            <div class="card-header-actions">     
              <button data-toggle="tooltip" title="Refresh" class="btn btn-sm btn-primary ml-4" v-on:click="refresh()" style="margin-right:1.5rem" type="button"><i class="fa fa-refresh"></i></button>                   
            </div>
          </div>   
          <div class="box" id="addform">
            <form @submit.prevent="validateForm('form-1')" data-vv-scope="form-1">
              <b-row>
                <b-col md="6" >
                  <b-col sm="12" >
                  <b-form-group label="Delivery Agent"  :label-cols="4" >
               
                      <!-- <b-form-select class="form-control input" v-model="customer.deliveryagentmasterid" name="deliveryagentname" v-validate="'required|'" 
                      :class="{'input': true, 'text-danger': errors.has('form-1.deliveryagentname') }" >
                        <option :value="selected" >Select</option>
                        <option :value="customer.deliveryagentmasterid"  v-for="agent in data1" v-bind:value="agent.deliveryagentmasterid">{{ agent.deliveryagentfirstname}} {{ agent.deliveryagentlastname}}-{{ agent.deliveryagentmasterid}}</option>
                        <span style="width: 270px;" v-show="errors.has('form-1.deliveryagentname')" class="help text-danger">{{ errors.first('form-1.deliveryagentname') }}</span> 
                  </b-form-select> -->
                  <v-select  v-model="customer.deliveryagentmasterid" :options="data1" placeholder="Select Delivery Agent" @input="selectdeliveryagent(customer.deliveryagentmasterid)"  name="deliveryagentname" v-validate="'required|'" 
                  :class="{'input': true, 'text-danger': errors.has('form-1.deliveryagentname') }" >
                  </v-select>
                  <span style="width: 270px;" v-show="errors.has('form-1.deliveryagentname')" class="help text-danger">{{ errors.first('form-1.deliveryagentname') }}</span> 
                  </b-form-group>
                </b-col>
                </b-col>
                <b-col md="6" >
                 <b-button type="submit" size="md" class="mr-4" variant="primary">Search</b-button>
                </b-col>
              </b-row>               
            </form>
          </div>

           <b-col sm="12" class="text-right">
               <p > <b>Total Records :<span style="color:red;margin-right: 10px;">{{ this.totalRows}}</span></b> </p>
              </b-col> 
          <b-col sm="12" >
           <b-table show-empty stacked="md" :busy="isBusy" :items="listingitems" :fields="fields"  :current-page="currentPage"  :per-page="perPage"  :outlined="outlined"  >
              <div slot="table-busy" class="text-center text-danger my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong>Loading...</strong>
              </div>  
               <template slot="actions" slot-scope="row">
                 <span   style="cursor:pointer;">
                    <span v-if="row.item.status==null" data-toggle="tooltip" title="Approve">
                    <span    @click="makerequest(row.item)" class="badge badge-success" style="font-size: 12px;margin-left: 5px;">Make a Request</span>
                  </span>
                  <span v-else>
                    {{row.item.status}}
                  </span>
                  
                  </span>
               </template>           
            </b-table>
          </b-col>

          <b-col md="12" class="my-1 " v-if="this.totalRows > 10">
            <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                class="my-0"
              ></b-pagination>
          </b-col>   
        </b-card>
      </b-col>
     </b-row>      
  </div>
</template>

<script>
import CONSTANTS from '@/utils/constants'
import Utils from '@/utils'
export default {
  data: function() {
    return {
      selected:'',
      name: 'allocation',
      data: [],
      DAPendingStatus: [],
      data1: [],
      pincodeallocatedata: [],
      allocatedata: [],
      toggleInfo: false,
      toggleInfo2: false,
      toggleDeAllocateInfo: false,
      allocated: [],
      customer: {},
      totalassgntxt: 'totalassgntxt',
      modalvalue: 'modalvalue',
      filterdata: [],
      filterdata1: [],
      filterdata2: [],
      shipment:"",
      alloctionId:"",
      isSearchDAPendingStatus: 0,
      DAAvaliablePickUPListData: 0,
      totalRows: 0,
      currentPage: 1,
        perPage:  10,
        pageOptions: [5, 10, 15],
      isBusy: false,
      outlined:true,
      fields: [
      { key: 'shippingid', label: 'Shipping Id', sortable: true, sortDirection: 'desc' },
      { key: 'rider_name', label: 'Rider Name', sortable: true, sortDirection: 'desc' },
      { key: 'lastmodifieddate', label: 'Modified Date', sortable: true, sortDirection: 'desc' },
      { key: 'customer_name', label: 'Customer Name', sortable: true, sortDirection: 'desc' },
      { key: 'shipmentstatus', label: 'Shipment Status', sortable: true, sortDirection: 'desc' },
      { key: 'actions', label: 'Action', sortable: true, sortDirection: 'desc' },
      ],
        listingitems: [],
        deliveryagent:"",
        shippingid:'',
    
    }
  },
  created: function() {
    this.displaydata()
  },
  methods: {
    validateForm(scope) {
      this.$validator.validateAll(scope).then((result) => {
        if (result) {
          this.showData()
        }
      })
    },

    
    displaydata: function() {
      var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
    
      //console.log("hello"+userInfo.sysusermasterid);
     if(userInfo.sysusermasterid==25 || userInfo.sysusermasterid==39)
     {
     
      let customerGetobj = {
        deliveryagentpincode: `${userInfo.pickuplocationpincode}`,
        isactive: '1',
        usertype:'4',

      }
      this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/deliveryagentmastergetall`, customerGetobj)
        .then((result) => {
          this.data1 = result.body;
          var data = [];
 
          result.body.forEach(function (srData) {
            data.push({
              key:srData.deliveryagentmasterid,
              label:srData.deliveryagentmasterid+ ' - '+srData.deliveryagentfirstname+ ' - '+srData.deliveryagentlastname
            });
          });
          this.data1 = data;
          // this.data1.sort(this.GetSortOrder('deliveryagentfirstname'))
        })
        .catch((ex) => {
          console.log('error', ex)
        })
     }
   
     else
     {
      let customerGetobj = {
        deliveryagentpincode: `${userInfo.pickuplocationpincode}`,
        isactive: '1'

      }
      this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/deliveryagentmastergetall`, customerGetobj)
        .then((result) => {
          this.data1 = result.body;
          var data = [];
 
          result.body.forEach(function (srData) {
            data.push({
              key:srData.deliveryagentmasterid,
              label:srData.deliveryagentmasterid+ ' - '+srData.deliveryagentfirstname+ ' - '+srData.deliveryagentlastname
            });
          });
          this.data1 = data;
          // this.data1.sort(this.GetSortOrder('deliveryagentfirstname'))
        })
        .catch((ex) => {
          console.log('error', ex)
        })
      
    }
 
      
    },
    
    GetSortOrder : function(prop) {
        return function(a, b) {
            if (a[prop] > b[prop]) {
                return 1;
            } else if (a[prop] < b[prop]) {
                return -1;
            }
            return 0;
        }

    },

    showData: function() {
         var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)

      var deliveryagent_id = (this.customer.deliveryagentmasterid == undefined ? "":this.customer.deliveryagentmasterid.key)
      console.log("###########",deliveryagent_id)
      this.isBusy = true;
      // this.isBusy2 = true;
      const obj = {
        deliveryagentmasterid: `${deliveryagent_id}`,
        // deliveryagentmasterid:607,
        // hub_id:`${userInfo.pickuplocationmasterid}`,
      }
      // console.log("obj",obj);
     this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getofdshipmentsforrider`,obj)
        .then((result) => {
         // console.log("Result",result);
           if (result.body.returnmsg == 'Successful') {
            this.isBusy = !this.isBusy
            // console.log('Data',this.data);
            this.listingitems  = result.body.returnvalue;
            // console.log("listingitems",this.listingitems);
            // this.imgpath=result.body.returnvalue;
            // console.log("image",this.imgpath);
            // this.agenti
            this.totalRows = result.body.returnvalue.length
            // console.log("TotalsRow", this.totalRows);
          } else {
            this.isBusy = !this.isBusy
            this.listingitems  = [];
             this.totalRows = 0;
            // this.totalRows = result.body.returnvalue.length
          }
        
         
        })
        .catch((ex) => {
          console.log('error', ex)
        })
    },

    makerequest:function(value){
       var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);
      this.deliveryagent=value.deliveryagentmasterid;
      this.shippingid=value.shippingid;
        var requestObj = {
        deliveryagentmasterid: this.deliveryagent,
        shippingid:this.shippingid,
        created_by:`${userInfo.sysemailid}`,

      };
      // console.log("requestObj",requestObj);
      // return false;
       this.$http
          .post(
            `${CONSTANTS.MIGRATION_API_URL}/make_shipdeliveryrequest`,
            requestObj
          )
          .then(result => {
            
      if (result.body.returnmsg ==='Successful' ) {
            // this.$fire({
            //       text:  result.body.returnvalue,
            //       type: "success",
            //       timer: 30000
            //     });
            alert(result.body.returnvalue);
            this.showData();
              }
            else{
               // this.$fire({
               //    text: result.body.returnvalue,
               //    type: "error",
               //    timer: 30000
               //  });
               alert(result.body.returnvalue);
            }
          })

          .catch(ex => {
            console.log("error", ex);
          });
          // this.showData();
    },

    refresh:function() {
      this.showData();
    },

    selectdeliveryagent(value_vehicle) {
        if(value_vehicle==null){
          this.deliveryagentid = '';
          this.displaydata();
        }
         console.log("value_vehicle : ",value_vehicle);
    },
  },
  // filters: {
  //   capitalize: function(value) {
  //     if (!value) return ''
  //     value = value.toString()
  //     return value.charAt(0).toUpperCase() + value.slice(1)
  //   }
  // }
};
</script>

